<script lang="ts">
export default { name: 'PinCreate' };
</script>

<script setup lang="ts">
//COMPONENTS
import GStepper from '@/components/GStepper/index.vue';
import GStepperItem from '@/components/GStepper/components/GStepperItem.vue';
import PinCreateForm from '../PinCreateForm/index.vue';
import PinCreateSuccess from '../PinCreateSuccess/index.vue';

// COMPOSABLES
import { usePinCreate } from './usePinCreate';

// TYPES
import type { PinEmits } from '../../types/pin.type';

const emits = defineEmits<PinEmits>();

const { step, PinCreateStep } = usePinCreate();
</script>

<template>
  <GStepper
    hide-left-header
    hide-right-header
    v-model="step"
    data-test="pin:create"
  >
    <GStepperItem dot :value="PinCreateStep.CREATE">
      <PinCreateForm @close="emits('close')" />
    </GStepperItem>
    <GStepperItem dot :value="PinCreateStep.SUCCESS">
      <PinCreateSuccess @close="emits('close')" />
    </GStepperItem>
  </GStepper>
</template>
